export default (state) => state.authentication.errorMessage
